import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  href: "https://www.bcu.org/Legal/Privacy-Policy",
  target: "_blank"
}

import { computed } from "vue";
import { useStore } from "vuex";

interface Props {
  externalLinks: boolean;
  lenderId: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterRefi',
  props: {
    externalLinks: { type: Boolean, default: false },
    lenderId: { default: 0 }
  },
  setup(__props: any) {



const year = computed<number>(() => {
  return new Date().getFullYear();
});
const store = useStore();
const identityUrl = computed(() => store.state.lenderData?.identityUrl);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("p", null, [
      _cache[1] || (_cache[1] = _createTextVNode(" By using this site, you accept our ", -1)),
      _createElementVNode("a", {
        href: `${identityUrl.value}/Home/Terms`,
        target: "_blank"
      }, "Terms of Use", 8, _hoisted_2),
      _cache[2] || (_cache[2] = _createTextVNode(" and ", -1)),
      (__props.lenderId === 1023)
        ? (_openBlock(), _createElementBlock("a", _hoisted_3, "Privacy Policy"))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: 'privacyPolicy', query: { lid: __props.lenderId } },
            target: "_blank"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Privacy Policy ", -1)
            ]))]),
            _: 1
          }, 8, ["to"]))
    ]),
    _createElementVNode("p", null, "© " + _toDisplayString(year.value) + " Student Choice. All rights reserved.", 1)
  ]))
}
}

})